import { forEach, omit } from 'lodash';
import {
  GET_LOTS_DONE,
  ADD_LOT_DONE,
  EDIT_LOT_DONE,
  GET_LOT_DONE,
  DELETE_LOT_DONE
} from '../actions/constantsActions';

const parkingLotReducer = (state = {}, action) => {
  const { type, payload } = action;
  const newState = {};

  switch (type) {
    case GET_LOTS_DONE:
      forEach(payload, (lot) => {
        newState[lot.id] = lot;
      });

      return {
        ...state,
        ...newState
      };

    case ADD_LOT_DONE:
      newState[payload.id] = payload;

      return {
        ...state,
        ...newState
      };

    case GET_LOT_DONE:
      newState[payload.id] = payload;

      return {
        ...state,
        ...newState
      };

    case EDIT_LOT_DONE:
      newState[payload.id] = payload;

      return {
        ...state,
        ...newState
      };

    case DELETE_LOT_DONE:
      return omit(state, payload)

    default:
      return state;
  }
};

export default parkingLotReducer;
